import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import AddNotification from "../../Modals/addNotification";
import AddIcon from '@mui/icons-material/Add';
import NotificationsList from "../../features/manageNotifications/notificationsList";
import React from "react";
import Panigation from "../../components/Panigation";
import { useDeleteNotificationsMutation, useLazyGetNotificationsQuery } from "../../services/notification";
import { isValidInput } from "../../utils/validations";
import { useGetUsersQuery, useLazyGetUsersQuery } from "../../services/user";
import { useGetTemplateQuery, useLazyGetTemplateQuery } from "../../services/settings";
import type { AdminUser, NotificationTemplate } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState('default');

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [getNotification] = useLazyGetNotificationsQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [deleteNotification] = useDeleteNotificationsMutation()
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.ceil(totalCount / 10);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const getNotificationList = async () => {
    setIsLoading(true);
    try {
      const response = await getNotification({
        search: debouncedSearchTerm,
        start: page,
        length: 10
      }).unwrap();

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0)
      } else {
        setRows(response?.data?.response_object || []);
        setTotalCount(0);
      }

    } catch (error) {
      console.log(error);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDelete = async () => {
    if (!selectedId) return;
    try {
      await deleteNotification({ id: selectedId }).unwrap();
      showToast("Notification deleted successfully");
      getNotificationList()
    } catch (e: any) {
      showError(e?.data?.message || "Failed to delete Notification");
    }
    setDeleteOpen(false);
    setSelectedId(null);
  };

  useEffect(() => {
    getNotificationList()
  }, [debouncedSearchTerm, page])
  return (
    <>
      <div className="main_title">
        <h1>Notification Management</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Notification Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                  setPage(1);
                }
              }}
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value="broadcast">Broadcast</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpenModal(true)}><AddIcon /> Add Notification</Button>
          </div>
        </div>

        <NotificationsList rows={rows} isLoading={isLoading} handleDelete={handleDelete} setSelectedId={setSelectedId} />

        {totalCount > 0 && (
          <div className="pagination_wrapper">
            <Panigation
              module={rows}
              totalCount={totalCount}
              page={page}
              setPage={setPage}
              onPageChange={setPage}
              totalPages={totalPages}
            />
          </div>
        )}
      </div>

      <AddNotification open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} getNotificationList={getNotificationList} />
    </>
  );
};

export default ManageNotifications;
